import { render, staticRenderFns } from "./VideoLoop.vue?vue&type=template&id=517b2546"
import script from "./VideoLoop.vue?vue&type=script&lang=js"
export * from "./VideoLoop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports